import React from "react";
import { refaqLogo, refaqLogoCss } from "../utils/refaqBranding";

export default function RefaqLogo() {
  return <div className="refaq-brand-logo" style={{ padding: "8px 0", marginBottom: 18, maxWidth: "100%", boxSizing: "border-box" }}>
    <style>{refaqLogoCss}</style>
    <div className="refaq-logo-frame"><img src={refaqLogo} alt="Refaq logo" /></div>
  </div>;
}
